export const isMeAlias = (name: string) =>
  ['me', 'my', 'you', 'your', 'username'].includes(name);
